import { Slide, ToastContainer, toast, ToastOptions } from 'react-toastify';
import cn from 'classnames';
import 'react-toastify/dist/ReactToastify.css';
import { Messages } from 'constants/messages';
import { CloseIcon_24 } from 'assets/icons';
import styles from './Toast.module.css';

export enum ToastId {
  failedInternet = 'failedInternet',
}

type CloseButtonProps = {
  closeToast: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};
const CloseButton = ({ closeToast }: CloseButtonProps): JSX.Element => (
  <button onClick={closeToast} title={'Close'} className={styles.closeButton}>
    <CloseIcon_24 />
  </button>
);

export const Toast = (): JSX.Element => (
  <ToastContainer
    className={styles.toast__container}
    toastClassName={styles.toast}
    bodyClassName={styles.toast__body}
    closeButton={({ closeToast }) => <CloseButton closeToast={closeToast} />}
    closeOnClick={false}
    draggable={false}
    hideProgressBar={true}
    transition={Slide}
    position={'bottom-right'}
    autoClose={7000}
  />
);

interface Props {
  message: string;
  type: 'success' | 'error' | 'normal';
}

const ToastComponent = ({ message, type = 'success' }: Props): JSX.Element => (
  <div
    className={cn(
      styles.toast__content,
      type === 'normal' && styles.toast__content_normal,
    )}
  >
    <span className={cn(styles.toast__text, styles['toast__text_' + type])}>
      {message}
    </span>
  </div>
);

export const showSuccessToast = (message: string, options?: ToastOptions): void => {
  toast(() => <ToastComponent message={message} type={'success'} />, options);
};

export const showInfoToast = (message: string, options?: ToastOptions): void => {
  toast(() => <ToastComponent message={message} type={'normal'} />, {
    className: styles.toast_normal,
    ...options,
  });
};

export const showErrorToast = (message: string, options?: ToastOptions): void => {
  toast(() => <ToastComponent message={message} type={'error'} />, options);
};

export const showNetworkErrorToast = (options?: ToastOptions): void => {
  toast(() => <ToastComponent message={Messages.errorEnternet} type={'error'} />, {
    toastId: ToastId.failedInternet,
    ...options,
  });
};
